// extracted by mini-css-extract-plugin
export default {"tools":"Operations_tools__nFnwZ","container":"Operations_container__wkGJl","btn":"Operations_btn__F2oT2","menu":"Operations_menu__HQUjv","menuItem":"Operations_menuItem__rT940"};